import { EmergencyBanners, EmergencyBannersInput } from "./types"

export default function mapperEmergencyBanners(
  emergencyBannersInput: EmergencyBannersInput,
): EmergencyBanners {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!emergencyBannersInput) {
    return []
  }

  return emergencyBannersInput.map((emergencyBanner) => ({
    type: emergencyBanner.type,
    title: emergencyBanner.title,
    description: emergencyBanner.description,
    action: emergencyBanner.action
      ? {
          title: emergencyBanner.action.title,
          url: emergencyBanner.action.url,
          // Fix this the next time the file is edited. (Flow to TS)
          // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
          smartFaqId: emergencyBanner.action.smart_faq_id || null,
        }
      : null,
  }))
}
